
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 224"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"レイヤー 1"}},[_c('path',{attrs:{"d":"M86.35 157.92c0 8.59 0 21.15.33 32.71.33 11.23.66 24.12.66 26.76 0 5.62-1.65 6.61-7.93 6.61h-5.28c-6.28 0-7.93-1-7.93-6.61 0-3 .33-15.2.66-26.43.33-11.89.33-24.45.33-33V32.05c0-5.62-.66-7.93-3.64-7.93-1.32 0-3 .66-5.61 1.65-10.57 4-21.81 8.92-30.07 12.89-2.31 1-4 1.65-5.28 1.65-2.32 0-3.31-1.65-5.29-6l-1.32-3a11.15 11.15 0 01-1.32-5c0-2.64 2-3.63 6.28-5.29 12.55-4.5 31.71-12.1 44.27-17.72C70.49.66 73.47 0 79.41 0 85.69 0 87 1 87 5.62c0 5-.33 17.84-.33 22.13-.33 11.9-.33 27.09-.33 38.33z","fill":"#fff","opacity":".3"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h140v224H0z"}})])])])
          )
        }
      }
    